import { lazy } from "react";

const EmpresaLayout = lazy(() => import("../../empresa/EmpresaLayout.jsx"));

const EmpresaForm = lazy(() =>
      import("../../empresa/EmpresaForm.jsx")
);

const SucursalesLayout = lazy(() =>
      import("../../empresa/sucursales/SucursalesLayout.jsx")
);
const SucursalesList = lazy(() =>
      import("../../empresa/sucursales/SucursalesList.jsx")
);
const SucursalForm = lazy(() =>
      import("../../empresa/sucursales/SucursalForm.jsx")
);

const UsuarioLayout = lazy(() =>
      import("../../empresa/UsuarioLayout.jsx")
);
const UsuariosList = lazy(() =>
      import("../../empresa/usuarios/UsuariosList.jsx")
);
const UsuarioForm = lazy(() =>
      import("../../empresa/usuarios/UsuarioForm.jsx")
);

const PerfilesLayout = lazy(() =>
      import("../../empresa/perfiles/PerfilesLayout.jsx")
);

const FuncionesLayout = lazy(() =>
      import("../../empresa/funciones/FuncionesLayout.jsx")
);

const SIILayout = lazy(() =>
      import("../../empresa/sii/SIILayout.jsx")
);

const SIIForm = lazy(() =>
      import("../../empresa/sii/SIIForm.jsx")
);

const MiPlan = lazy(() =>
      import("../../empresa/MiPlan.jsx")
);

const FoliosManager = lazy(() =>
      import("../../empresa/folios/FolioManager.jsx")
);

const FoliosUtilizados = lazy(() =>
      import("../../empresa/folios/FoliosUtilizados.jsx")
);

const FoliosEnUso = lazy(() =>
      import("../../empresa/folios/FoliosEnUso.jsx")
);

const CertificadoManager = lazy(() =>
      import("../../empresa/certificados/CertificadoManager.jsx")
);

const ActividadesEconomicasLayout = lazy(() =>
      import("../../empresa/actividades_economicas/ActividadesEconomicasLayout.jsx")
);

const CajaManagerLayout = lazy(() =>
      import("../../empresa/cajas/CajaManagerLayout.jsx")
);

const CajaManager = lazy(() =>
      import("../../empresa/cajas/CajaManager.jsx")
);

const CajaForm = lazy(() => import("../../empresa/cajas/CajaForm.jsx"));


const empresaRoutes = [
      {
            path: "empresa",
            element: <EmpresaLayout />,
            children: [
                  { index: true, element: <EmpresaForm /> },
                  {
                        path: "sucursales",
                        element: <SucursalesLayout />,
                        children: [
                              { index: true, element: <SucursalesList /> },
                              { path: "nueva", element: <SucursalForm /> },
                              { path: "editar", element: <SucursalForm /> },
                        ],
                  },
                  {
                        path: "usuarios",
                        element: <UsuarioLayout />,
                        children: [
                              { index: true, element: <UsuariosList /> },
                              { path: "nuevo", element: <UsuarioForm /> },
                              { path: "editar/:token", element: <UsuarioForm /> },
                        ],
                  },
                  { path: "perfiles", element: <PerfilesLayout /> },
                  { path: "funciones", element: <FuncionesLayout /> },
                  {
                        path: "sii",
                        element: <SIILayout />,
                        children: [
                              { index: true, element: <SIIForm /> },
                              { path: "certificados", element: <CertificadoManager /> },
                              { path: "actividades-economicas", element: <ActividadesEconomicasLayout /> },
                        ],
                  },
                  { path: "plan", element: <MiPlan /> },
                  { path: "folios", element: <FoliosManager /> },
                  { path: "folios/en-uso", element: <FoliosEnUso /> },
                  { path: "folios/utilizados", element: <FoliosUtilizados /> },
                  { path: "certificados", element: <CertificadoManager /> },
                  { path: "actividades-economicas", element: <ActividadesEconomicasLayout /> },
                  {
                        path: "cajas",
                        element: <CajaManagerLayout />,
                        children: [
                              { index: true, element: <CajaManager /> },
                              { path: "nueva", element: <CajaForm /> },
                              { path: "editar/:token", element: <CajaForm /> },
                        ]
                  }
            ],
      },
];

export default empresaRoutes;